export default __webpack_public_path__ + "static/media/features_card5.3bb96f99.svg";